import React, { FC, useEffect } from "react";
// hooks
import { useAppDispatch, useAppSelector } from "src/hooks";
import Router from "next/router";
// redux
import { variablesStateSelector } from "src/redux/slices/variables/selectors";
import { VariablesState, updateVariable } from "src/redux/slices/variables";
// const
import { SEARCH_AS_I_MOVE } from "src/constants/variables";
// theme
import { Checkbox, SearchAsIMoveContainer, SearchAsIMoveWrapper } from "./map.styles";
// types
import { ParsedUrlQuery } from "querystring";
import { amplitudeEvent, formatEventName } from "src/libs/amplitude";
import { Action } from "src/theme/typography";

interface ISearchAsMoveProps {
  callback: (value: boolean, prevQuery: ParsedUrlQuery | undefined) => void;
}

const SearchAsMove: FC<ISearchAsMoveProps> = ({ callback }) => {
  const dispatch = useAppDispatch();
  const VariablesStateSelected: VariablesState = useAppSelector(variablesStateSelector);

  const searchOnMove = VariablesStateSelected[SEARCH_AS_I_MOVE];

  const toggleSearchOnMove = (value: boolean) => {
    const prevQuery = Router.router?.query;
    dispatch(updateVariable({ name: SEARCH_AS_I_MOVE, value }));
    callback?.(value, prevQuery);
  };

  useEffect(() => {
    return () => {
      // clear values on unmount
      dispatch(updateVariable({ name: SEARCH_AS_I_MOVE, value: false }));
    };
  }, []);

  return (
    <SearchAsIMoveWrapper>
      <SearchAsIMoveContainer
        onClick={() => {
          toggleSearchOnMove(!searchOnMove);
          amplitudeEvent(formatEventName("search_results", "map", "search_as_i_move"));
        }}
        checked={searchOnMove}
      >
        <Checkbox
          type="checkbox"
          id="searchOnMoveCheckbox"
          name="searchOnMoveCheckbox"
          checked={searchOnMove}
          onChange={(e) => toggleSearchOnMove(e.target.checked)}
        />
        <Action as="label" htmlFor="searchOnMoveCheckbox" style={{ pointerEvents: "none" }}>
          Search as I move the map
        </Action>
      </SearchAsIMoveContainer>
    </SearchAsIMoveWrapper>
  );
};

export default React.memo(SearchAsMove, () => true);
